import { StyledHeader, Book, Button, Ready } from "./styled/Header.styled";
import { Container } from "./styled/Container.styled";
import HeaderModule from "./Header.module.css";

const Header = () => {
  return (
    <StyledHeader>
      <Container>
        {/* <Ready>Ready to Ride The Life Adventure?</Ready>
        <Book>Mitsubishi New Xpander</Book> */}
        <Book className={HeaderModule.mmcBold}>Get Yours!</Book>
        <Button
          href="https://wa.me/+628116541800?text=[NXP] Halo Sardana Berlian. Saya tertarik dengan produk Mitsubishi New Xpander."
          target="_blank"
        >
          <span>Chat US</span>
        </Button>
      </Container>
    </StyledHeader>
  );
};

export default Header;
